(function () {
    'use strict';

    angular.module('app').controller('rateCardDetailsModalController', rateCardDetailsModalController);

    rateCardDetailsModalController.$inject = [
        '$rootScope',
        'Units',
        'serviceProfile',
        'rateDetails',
        '$uibModalInstance',
        'Carrier',
        'aborter',
        'CommonService',
        '$timeout',
        'toastr',
        '$q',
        'patternFactory'
    ];

    function rateCardDetailsModalController(
        $rootScope,
        Units,
        serviceProfile,
        rateDetails,
        $uibModalInstance,
        Carrier,
        aborter,
        CommonService,
        $timeout,
        toastr,
        $q,
        patternFactory
    ){
        let vm = this;
        vm.rate = {};
        vm.addToList = addToList;
        vm.serviceProfile = serviceProfile;
        vm.dismiss = dismiss;
        vm.searchForZones = searchForZones;
        vm.deleteRate = deleteRate;
        vm.zones = [];
        vm.compare = compare;
        vm.isInvalid = CommonService.isInputInvalid;
        vm.computeForTransitTime = computeForTransitTime;
        vm.setTouched = setTouched;
        vm.hasPatternError = hasPatternError;
        vm.setTransitTimeInHrs = setTransitTimeInHrs;
        vm.roundDown = roundDown;
        vm.changeRateType = changeRateType;
        vm.patterns = {
            noZeroDec: patternFactory.noZeroDecimal,
            wholeNumber: patternFactory.wholeNumber,
            decimal: patternFactory.decimal
        };
        let packageTypes = [{
            label: 'Pallet',
            value: 'pallet',
        }, {
            label: 'Carton',
            value: 'carton'
        }];
        const weightUnit = Units.weightUnit.find(unit=>unit.value === $rootScope.GlobalProfile.office.weightUnit).short.toUpperCase();
        const measureUnit = Units.measureUnit.find(unit=>unit.short === $rootScope.GlobalProfile.office.measureUnit).short.toUpperCase();
        vm.rateTypes = angular.getObjVal(serviceProfile, 'service.rateCategories');

        vm.inputTypes = {
            collapsable: angular.getObjVal(rateDetails, 'type.value') === 'bypallet',
            // Volume Based
            perVolumeRate:{
                type: 'unit',
                tooltip: 'Please enter a valid number',
                pattern: vm.patterns.decimal,
                required: true
            },
            roundDecimalToNearestVolume:{
                type: 'number',
                tooltip: 'Please enter a valid number',
                pattern: vm.patterns.decimal,
                required: true
            },
            volumeOffset:{
                type: 'unit',
                tooltip: 'Please enter a valid number',
                pattern: vm.patterns.decimal,
                required: true
            },
            measureUnit:{
                type: 'dropdown',
                placeHolder:"Measure Unit",
                // tooltip: 'Please enter a valid number',
                required: true,
                items: ['cm','m','in','ft']
            },
            reference:{
                type: 'number',
                isDisabled:function(){
                    return true
                },
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec
            },
            itemValue: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                required: true
            },
            perKgRate: {
                type: 'unit',
                tooltip: 'Please enter a valid number',
                pattern: vm.patterns.decimal,
                isRequired: function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            per3kg: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired:  function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            per5kg: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired:  function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            perOver5kg: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired:  function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            basic: {
                type: 'unit',
                tooltip: 'Please enter valid number',
                pattern: vm.patterns.decimal,
                isRequired:  function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum ;
                }
            },
            minimum: {
                type: 'unit',
                tooltip: 'Please enter valid number',
                pattern: vm.patterns.decimal,
                isRequired:  function () {
                    return !vm.rate.perKgRate && !vm.rate.per3kg && !vm.rate.per5kg &&
                        !vm.rate.perOver5kg && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            packageType: {
                type: 'dropdown',
                items: packageTypes,
                viewName: 'label',
                valueName: 'value',
                refresh: getPackageTypeList
            },
            minQuantity: {
                type: 'number',
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minQuantity && +rate.maxQuantity && +rate.minQuantity > +rate.maxQuantity) {
                        input.tooltip = 'Min quantity must be lower than max quantity';
                        return true;
                    }
                    return false;
                }
            },
            maxQuantity: {
                type: 'number',
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minQuantity && +rate.maxQuantity && +rate.minQuantity > +rate.maxQuantity) {
                        input.tooltip = 'Max quantity must be higher than min quantity';
                        return true;
                    }
                    return false;
                }
            },
            minDeadWeight: {
                type: 'unit',
                unit: weightUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minDeadWeight && +rate.maxDeadWeight && +rate.minDeadWeight > +rate.maxDeadWeight) {
                        input.tooltip = 'Min dead weight must be lower than max dead weight';
                        return true;
                    }
                    return false;
                },
                collapsable: true
            },
            maxDeadWeight: {
                type: 'unit',
                unit: weightUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minDeadWeight && +rate.maxDeadWeight && +rate.minDeadWeight > +rate.maxDeadWeight) {
                        input.tooltip = 'Max dead weight must be higher than min dead weight';
                        return true;
                    }
                    return false;
                },
                collapsable: true
            },
            minLength: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minLength && +rate.maxLength && +rate.minLength > +rate.maxLength) {
                        input.tooltip = 'Min length must be lower than max length';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMinVolume(rate);
                },
                collapsable: true
            },
            maxLength: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minLength && +rate.maxLength && +rate.minLength > +rate.maxLength) {
                        input.tooltip = 'Max length must be higher than min length';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMaxVolume(rate);
                },
                collapsable: true
            },
            minWidth: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minWidth && +rate.maxWidth && +rate.minWidth > +rate.maxWidth) {
                        input.tooltip = 'Min width must be lower than max width';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMinVolume(rate);
                },
                collapsable: true
            },
            maxWidth: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minWidth && +rate.maxWidth && +rate.minWidth > +rate.maxWidth) {
                        input.tooltip = 'Max width must be higher than min width';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMaxVolume(rate);
                },
                collapsable: true
            },
            minHeight: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minHeight && +rate.maxHeight && +rate.minHeight > +rate.maxHeight) {
                        input.tooltip = 'Min height must be lower than max height';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMinVolume(rate);
                },
                collapsable: true
            },
            maxHeight: {
                type: 'unit',
                unit: measureUnit,
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minHeight && +rate.maxHeight && +rate.minHeight > +rate.maxHeight) {
                        input.tooltip = 'Max height must be higher than min height';
                        return true;
                    }
                    return false;
                },
                ngChange: function (rate) {
                    calculateMaxVolume(rate);
                },
                collapsable: true
            },
            minCubicWeight: {
                type: 'unit',
                tooltip: 'Auto calculate',
                unit: `${measureUnit}<sup>3</sup>`,
                /*tooltip: 'Cubic conversion is required to enable cubic weight',
                hasError: function (rate) {
                    let input = this;
                    if (+rate.minCubicWeight && +rate.maxCubicWeight && +rate.minCubicWeight > +rate.maxCubicWeight) {
                        input.tooltip = 'Min cubic volume must be lower than max cubic volume';
                        return true;
                    }
                    return false;
                },*/
                isDisabled: function () {
                    /*let input = this;
                    if(!vm.rate['cubicConversion'])
                        input.tooltip = 'Cubic conversion is required to enable this field';
                    else
                        input.tooltip = 'Please enter positive number';
                    return !vm.rate['cubicConversion'];*/
                    return false;
                },
                collapsable: true
            },
            maxCubicWeight: {
                type: 'unit',
                tooltip: 'Auto calculate',
                unit: `${measureUnit}<sup>3</sup>`,
                /*hasError: function (rate) {
                    let input = this;
                    if (+rate.minCubicWeight && +rate.maxCubicWeight && +rate.minCubicWeight > +rate.maxCubicWeight) {
                        input.tooltip = 'Max cubic volume must be higher than min cubic weight';
                        return true;
                    }
                    return false;
                },*/
                isDisabled: function () {
                    /*let input = this;
                    if(!vm.rate['cubicConversion'])
                        input.tooltip = 'Cubic conversion is required to enable this field';
                    else
                        input.tooltip = 'Please enter positive number';
                    return !vm.rate['cubicConversion'];*/
                    return false
                },
                collapsable: true
            },
            secondItemOnwardsIncrementAmount: {
                type: 'unit',
                pattern: vm.patterns.decimal,
                tooltip: 'Please Enter Amount'
            },
            cubicConversion: {
                type: 'unit',
                unit: `${weightUnit}/${measureUnit} <sup>3</sup>`,
                pattern: vm.patterns.decimal,
                tooltip: 'Please enter Cubic Conversion value'
            },
            ratePerKm: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired: function () {
                    return !vm.rate.ratePerKm && !vm.rate.basic && !vm.rate.minimum;
                }
            },
            tailGateHourlyRate: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                required: true,
                ngChange: function () {
                    calculateMinRate(vm.rate);
                    calculateMaxRate(vm.rate);
                }
            },
            hourlyRate: {
                type: 'unit',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                required: true,
                ngChange: function () {
                    calculateMinRate(vm.rate);
                    calculateMaxRate(vm.rate);
                }
            },
            minDuration: {
                type: 'unit',
                unit: 'HRS',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired: function () {
                    return !+vm.rate.minDuration && !+vm.rate.maxDuration;
                },
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minDuration && +rate.maxDuration && +rate.minDuration > +rate.maxDuration) {
                        input.tooltip = 'Min duration must be lower than max duration';
                        return true;
                    }
                    return false;
                },
                ngChange: function () {
                    calculateMinRate(vm.rate);
                }
            },
            maxDuration: {
                type: 'unit',
                unit: 'HRS',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired: function () {
                    return !+vm.rate.minDuration && !+vm.rate.maxDuration;
                },
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minDuration && +rate.maxDuration && +rate.minDuration > +rate.maxDuration) {
                        input.tooltip = 'Max duration must be higher than min duration';
                        return true;
                    }
                    return false;
                },
                ngChange: function () {
                    calculateMaxRate(vm.rate);
                }
            },
            minVariance: {
                type: 'unit',
                unit: '%',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired: function () {
                    return !+vm.rate.minVariance && !+vm.rate.maxVariance;
                },
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minVariance && +rate.maxVariance && +rate.minVariance > +rate.maxVariance) {
                        input.tooltip = 'Min variance must be lower than max variance';
                        return true;
                    }
                    return false;
                },
                ngChange: function () {
                    calculateMinRate(vm.rate);
                }
            },
            maxVariance: {
                type: 'unit',
                unit: '%',
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.noZeroDec,
                isRequired: function () {
                    return !+vm.rate.minVariance && !+vm.rate.maxVariance;
                },
                hasError: function (rate) {
                    let input = this;
                    input.tooltip = 'Please enter positive number';
                    if (+rate.minVariance && +rate.maxVariance && +rate.minVariance > +rate.maxVariance) {
                        input.tooltip = 'Max variance must be higher than min variance';
                        return true;
                    }
                    return false;
                },
                ngChange: function () {
                    calculateMaxRate(vm.rate);
                }
            },
            minRate: {
                type: 'unit',
                tooltip: 'Auto calculate',
                pattern: vm.patterns.noZeroDec,
                isDisabled: function () {
                    return true;
                },
            },
            maxRate: {
                type: 'unit',
                tooltip: 'Auto calculate',
                pattern: vm.patterns.noZeroDec,
                isDisabled: function () {
                    return true;
                },
            },
            weightOffset: {
                type: 'unit',
                unit: weightUnit,
                tooltip: 'Please enter positive number',
                pattern: vm.patterns.decimal
            },
            weightIncrement: {
                type: 'unit',
                unit: weightUnit,
                tooltip: 'Please enter a positive number',
                pattern: vm.patterns.decimal,
            },
            minItemWeight: {
                type: 'unit',
                unit: weightUnit,
                tooltip: 'Please enter a minimum weight value',
                hasError: (rate) => {
                    if (+rate.maxItemWeight < +rate.minItemWeight) {
                        vm.inputTypes['minItemWeight'].tooltip = 'Min item weight should be less than max item weight.';
                        return true;
                    }
                    return false;
                }
            },
            maxItemWeight: {
                type: 'unit',
                unit: weightUnit,
                tooltip: 'Please enter a maximum weight value',
                hasError: (rate) => {
                    if (+rate.maxItemWeight < +rate.minItemWeight) {
                        vm.inputTypes['maxItemWeight'].tooltip = 'Max item weight should be greater than min item weight.';
                        return true;
                    }
                    return false;
                }
            }
        };

        init();

        function init() {
            $timeout(()=>{
                vm.rate = angular.copy(rateDetails);
                if (!vm.rate.type) {
                    vm.rate.type = vm.rateTypes[0];
                }
                var sorted=[];
                if(vm.rate.type.value ==='byweight'){
                    var order = [0,1,2,4,5,6,3,7,8,9,10,11,12,13,14]
                    for(let i=0; i < vm.rate.type.categories.length;i++ ){
                        var orderItem = order[i];
                        sorted.push(vm.rate.type.categories[orderItem])
                    }
                    vm.rate.type.categories = sorted
                }

                changeRateType(vm.rate.type);
                if(vm.rate.packageType){
                    const packageTypeObj = vm.inputTypes.packageType.items.find(type=>type.value === vm.rate.packageType || vm.rate.packageType.value);
                    const customType = {value: vm.rate.packageType, label: vm.rate.packageType};
                    if(!packageTypeObj){
                        packageTypes.push(customType)
                    }
                    vm.rate.packageType = packageTypeObj || customType;
                }else{
                    vm.rate.packageType = packageTypes[0];
                }

                if(vm.rate.weightIncrement) {
                    vm.rate.weightIncrement = Number(rateDetails.weightIncrement.split(' ')[0]);
                }
            });
            vm.id = rateDetails ? rateDetails.id : null;
        }

        function calculateMinVolume(rate) {
            if(rate.minLength || rate.minHeight || rate.minWidth){
                rate.minCubicWeight = rate.minLength * rate.minHeight * rate.minWidth;
            }
            else{
                rate.minCubicWeight = null;
            }
        }
        function calculateMaxVolume(rate) {
            if(rate.maxLength || rate.maxHeight || rate.maxWidth){
                rate.maxCubicWeight = rate.maxLength * rate.maxHeight * rate.maxWidth;
            }
            else{
                rate.maxCubicWeight = null;
            }
        }

        function calculateMinRate(rate) {
            const {hourlyRate, minDuration, minVariance} = rate;
            if(hourlyRate && minDuration && minVariance){
                const minRate = (hourlyRate * minDuration) * (1 - (minVariance / 100));
                rate.minRate = Math.round(minRate * 100) / 100;
            }else{
                rate.minRate = 0;
            }
        }

        function calculateMaxRate(rate) {
            const {hourlyRate, maxDuration, maxVariance} = rate;
            if(hourlyRate && maxDuration && maxVariance){
                const maxRate = (hourlyRate * maxDuration) * (1 + (maxVariance / 100));
                rate.maxRate = Math.round(maxRate * 100) / 100;
            }else{
                rate.maxRate = 0;
            }
        }
        function changeRateType(selected) {
            vm.inputTypes.collapsable = selected.value === 'bypallet' || selected.value === 'byweight';
            if(selected.value === 'byweight' && selected.categories.indexOf('weightIncrement') < 0) {
                selected.categories.push('weightIncrement');
            }
            if(selected.value === 'byweight' && selected.categories.indexOf('weightOffset') < 0 ) {
                selected.categories.push('weightOffset');
            }

            angular.forEach(selected.categories, function (category) {    
                if(category === 'packageType'){
                    return false;
                }

                // todo: need to fix this one here
                vm.rate[category] = vm.rate[category] || (vm.inputTypes[category].pattern === vm.patterns.noZeroDec ? null : 0);
            });
        }

        function roundDown(model) {
            //vm.rate[model] = angular.isNumber(parseFloat(vm.rate[model])) ? parseFloat(vm.rate[model]).roundDown() : null;
        }

        function searchForZones(model) {
            vm.isFetching = true;
            vm.zones = [];
            const reqParams = {name: model, size: 200, draft: false};
            new aborter(() => {
                callZonesApi(reqParams).then(() => {
                    vm.isFetching = false;
                }).catch(() => {
                    vm.isFetching = false;
                });
            }, 500);
        }

        function callZonesApi(reqParams) {
            const defer = $q.defer();
            Carrier.getZonePostcodeFiles(angular.getObjVal(serviceProfile, 'carrierProfile.id'), data => {
                    vm.zones = data.content;
                    defer.resolve()
                },
                error => {
                    toastr.error('Unable to get zones', error.message);
                    defer.reject()
                }, JSON.parse(JSON.stringify(reqParams)));

            return defer.promise;
        }

        function cleanPayload(data) {
            return {
                zoneFrom: angular.getObjVal(data, 'zoneFrom.id'),
                zoneTo: angular.getObjVal(data, 'zoneTo.id'),
                zoneOrigin: angular.getObjVal(data, 'zoneOrigin.id'),
                zoneDestination: angular.getObjVal(data, 'zoneDestination.id'),
                basic: data.basic,
                minimum: data.minimum,
                ratePerKg:data.perKgRate,
                ratePerKm: data.ratePerKm,
                transitTimeEarliest: data.transitTimeEarliest,
                transitTimeLatest: data.transitTimeLatest,
                rate3kg: data.rate3kg,
                rate5kg: data.rate5kg,
                rateOver5Kg: data.rateOver5Kg,
                reciprocal: data.reciprocal,
                rateType: angular.getObjVal(data, 'type.value'),
                packageType: angular.getObjVal(data, 'type.value') ==="byvolume"? null: angular.getObjVal(data, 'packageType.value'),
                itemValue: data.itemValue,
                minQuantity: data.minQuantity,
                maxQuantity: data.maxQuantity,
                minDeadWeight: data.minDeadWeight,
                maxDeadWeight: data.maxDeadWeight,
                minLength: data.minLength,
                maxLength: data.maxLength,
                minWidth: data.minWidth,
                maxWidth: data.maxWidth,
                minHeight: data.minHeight,
                maxHeight: data.maxHeight,
                minCubicWeight: data.minCubicWeight,
                maxCubicWeight: data.maxCubicWeight,
                cubicConversion: data.cubicConversion,
                bulkFlatRate: data.bulkFlatRate,
                filledContainer: data.filledContainer,
                tailGateHourlyRate: data.tailGateHourlyRate,
                hourlyRate: data.hourlyRate,
                minDuration: data.minDuration,
                minVariance: data.minVariance,
                minRate: data.minRate,
                maxDuration: data.maxDuration,
                maxVariance: data.maxVariance,
                maxRate: data.maxRate,
                weightOffset: data.weightOffset,
                weightIncrement:data.weightIncrement,
                minItemWeight: data.minItemWeight,
                maxItemWeight: data.maxItemWeight,
                secondItemOnwardsIncrementAmount: Number(data.secondItemOnwardsIncrementAmount),
                weightUnit: Units.weightUnit.find(unit=>unit.value === $rootScope.GlobalProfile.office.weightUnit).value.toLowerCase(),
                measureUnit: angular.getObjVal(data, 'type.value') ==="byvolume"? data.measureUnit : Units.measureUnit.find(unit=>unit.short === $rootScope.GlobalProfile.office.measureUnit).short.toLowerCase() ,
                perVolumeRate: data.perVolumeRate,
                roundDecimalToNearestVolume:data.roundDecimalToNearestVolume,
                volumeOffset : data.volumeOffset,
                reference : data.reference,
                chargeDeadWeight: data.chargeDeadWeight,
                excludeChargeableWeightValidation:data.excludeChargeableWeightValidation
            };
        }

        function computeForTransitTime(options, model) {
            const names = {
                forEarliest: {
                    hrs: 'transitTimeEarliestHrs',
                    d: 'transitTimeEarliestD',
                    w: 'transitTimeEarliestW'
                },
                forLatest: {
                    hrs: 'transitTimeLatestHrs',
                    d: 'transitTimeLatestD',
                    w: 'transitTimeLatestW'
                }
            };
            const transitNames = options.forEarliest ? names.forEarliest : names.forLatest;
            if (options.max === 24) {
                if (vm.rate[model]) {
                    const days = Math.floor(vm.rate[model] / 24);
                    const remHrs = vm.rate[model] % 24;
                    if (days)
                        vm.rate[transitNames.d] = days;
                    vm.rate[model] = Math.floor(remHrs);
                }
            } else if (options.max === 7) {
                if (vm.rate[model]) {
                    const weeks = Math.floor(vm.rate[model] / 7);
                    const remD = (parseFloat(vm.rate[model])).toFixed(2) % 7;

                    const remHrs = (remD % 1) * 24;
                    if (weeks)
                        vm.rate[transitNames.w] = weeks;
                    if (remHrs)
                        vm.rate[transitNames.hrs] = Math.floor(remHrs);
                    vm.rate[model] = Math.floor(remD);
                }
            } else {
                if (vm.rate[model]) {
                    const remD = (vm.rate[model] % 1) * 7;
                    const remHrs = (remD % 1) * 24;
                    vm.rate[model] = Math.floor(vm.rate[model]);
                    if (remD)
                        vm.rate[transitNames.d] = Math.floor(remD);
                    if (remHrs)
                        vm.rate[transitNames.hrs] = Math.floor(remHrs);
                }
            }
        }

        function setTouched(transitModel, transitName) {
            $timeout(() => {
                const earliestInputs = ['transitEarliestW', 'transitEarliestD', 'transitEarliestHrs'];
                const latestInputs = ['transitLatestW', 'transitLatestD', 'transitLatestHrs'];
                const inputs = transitModel === 'transitTimeEarliest' ? earliestInputs : latestInputs;
                const inputsTouched = inputs.every(input => {
                    return vm.rateCardForm[input].$touched;
                });
                if (setTransitTimeInHrs(transitModel) || inputsTouched) {
                    vm.rateCardForm[transitName].$setTouched();
                }
            });
        }
        function getPackageTypeList(search) {
            let newCount = packageTypes.slice();
            if (search && newCount.indexOf(newCount.find(item=>item.value === search || item.label === search)) === -1) {
                newCount.unshift({
                    label: search,
                    value: search
                });
            }
            vm.inputTypes.packageType.items = newCount;
        }
        function hasPatternError(...inputNames) {
            const hasError = inputNames.find(name => {
                return !!angular.getObjVal(vm.rateCardForm[name], '$error.pattern');
            });
            return !!hasError;
        }

        function setTransitTimeInHrs(name) {
            const transitEarliest = ['transitTimeEarliestW', 'transitTimeEarliestD', 'transitTimeEarliestHrs'];
            const transitLatest = ['transitTimeLatestW', 'transitTimeLatestD', 'transitTimeLatestHrs'];
            const transitNames = name === 'transitTimeEarliest' ? transitEarliest : transitLatest;
            vm.rate[name] = null;
            angular.forEach(transitNames, (key, index) => {
                if (angular.isNumber(parseFloat(vm.rate[key])) && !isNaN(parseFloat(vm.rate[key]))) {
                    if (index === 0) {
                        vm.rate[name] += parseFloat(vm.rate[key]) * 7 * 24;
                    }
                    if (index === 1) {
                        vm.rate[name] += parseFloat(vm.rate[key]) * 24;
                    }
                    if (index === 2) {
                        vm.rate[name] += parseFloat(vm.rate[key]);
                    }
                }
            });
            return (vm.rate[name]);
        }

        function addToList(rate, form) {
            form.$setSubmitted();
            if (form.$invalid) {
                return false;
            }

            vm.isSaving = true;
            if (!vm.id) {
                Carrier.createServiceRateCard(vm.serviceProfile.id, data => {
                    vm.isSaving = false;
                    toastr.success('Rate successfully created');
                    $uibModalInstance.close();
                }, err => {
                    vm.isSaving = false;
                    toastr.error('Error on saving rate', err.message);
                }, cleanPayload(rate));
            } else {
                Carrier.updateServiceRateCard({serviceProfileId: vm.serviceProfile.id, rateId: vm.id}, data => {
                    vm.isSaving = false;
                    toastr.success('Rate successfully updated');
                    $uibModalInstance.close();
                }, err => {
                    vm.isSaving = false;
                    toastr.error('Error on updating rate', err.message);
                }, cleanPayload(rate));
            }
        }

        function deleteRate() {
            vm.isSaving = true;
            Carrier.deleteServiceRateCard({serviceProfileId: vm.serviceProfile.id, rateId: vm.id}, data => {
                vm.isSaving = false;
                toastr.success('Rate deleted');
                $uibModalInstance.close();
            }, err => {
                toastr.error('Error on deleting rate', err.message);
                vm.isSaving = false;
            });
        }

        function dismiss() {
            $uibModalInstance.dismiss();
        }

        function compare() {
            if (angular.getObjVal(vm, 'rate.transitTimeEarliest') && angular.getObjVal(vm, 'rate.transitTimeLatest')) {
                if (parseFloat(vm.rate.transitTimeEarliest) > parseFloat(vm.rate.transitTimeLatest)) {
                    vm.transitLatestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_LATEST';
                    vm.transitEarliestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_EARLIEST';
                    return true;
                }
                vm.transitLatestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_INVALID';
                vm.transitEarliestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_INVALID';
                return false;
            }
            vm.transitLatestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_INVALID';
            vm.transitEarliestTooltip = 'messages.warning.tooltip.TRANSIT_TIME_INVALID';
            return false;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/rateCardDetailsModalController.js